import RestAPI from '../../Common/restApi';
import { putWithCastleRequestToken } from '../../../Resources/Castle/Api';

export default class SetupApi {
  static advanceOnboardingState(form_data) {
    const reqUrl = '/api/v2/pro/setup/next_step';
    return RestAPI.updateWithFormData(reqUrl, form_data);
  }

  static setPassword(form_data) {
    const reqUrl = '/api/v2/pro/password';
    return putWithCastleRequestToken(reqUrl, form_data);
  }

  static fetchIsPasswordBlank() {
    const reqUrl = '/api/v2/pro/password';
    return RestAPI.get(reqUrl);
  }

  static hasNoWebsite(hasNoWebsite) {
    const reqUrl = '/api/v2/pro/setup/has_no_website';
    return RestAPI.postWithFormData(reqUrl, { has_no_website: hasNoWebsite });
  }

  static lookUpPhoneCarrierType(form_data) {
    const reqUrl = '/api/v2/pro/setup/look_up_phone_carrier_type';
    return RestAPI.postWithFormData(reqUrl, form_data);
  }

  static fetchOnboardingStep(stage = null) {
    return RestAPI.getWithFormData('/api/v2/pro/setup/next_step', { stage: stage });
  }

  static fetchAvailableIndustries() {
    return RestAPI.get('/api/v2/pro/setup/available_industries');
  }

  static fetchOnboardingCompleted() {
    return RestAPI.get('/alpha/organization/completed_setup_onboarding');
  }

  static fetchCalendlyLink() {
    return RestAPI.get('/alpha/calendly_link');
  }

  static setPasswordBannerDisplayState(data) {
    const reqUrl = '/alpha/password_banners';
    return RestAPI.updateWithFormData(reqUrl, data);
  }

  static fetchPasswordBannerState() {
    return RestAPI.get('/alpha/password_banners');
  }

  static fetchProductTourState() {
    return RestAPI.get('/alpha/product_tours/should_see_product_tour');
  }

  static updateProductTourCompletion(data) {
    const reqUrl = '/alpha/product_tours';
    return RestAPI.updateWithFormData(reqUrl, data);
  }
}
